import React from "react";
import { formatINR } from "../../utils/formatINR";

export function FundraiserProgress({ goal, raised, size = "lg", compact = false }) {
  const goalValue = Number(goal) || 0;
  const raisedValue = Number(raised) || 0;
  const percentage =
    goalValue > 0 ? Math.round((raisedValue / goalValue) * 100) : 0;
  const barWidth = Math.min(percentage, 100);

  const isLarge = size === "lg";

  if (compact) {
    return (
      <div className="w-full">
        <div className="flex items-center justify-between text-sm">
          <span>
            <span className="font-semibold text-[#FF6600]">
              {formatINR(raisedValue)}
            </span>
            <span className="text-gray-400"> / {formatINR(goalValue)}</span>
          </span>
          <span className="font-semibold text-gray-700">{percentage}%</span>
        </div>
        <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full rounded-full bg-gradient-to-r from-[#efc94c] to-[#FF6600] transition-all duration-700"
            style={{ width: `${barWidth}%` }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <div>
          <p
            className={`font-bold text-[#FF6600] ${isLarge ? "text-3xl" : "text-xl"}`}
          >
            {formatINR(raisedValue)}
          </p>
          <p className={`text-gray-500 ${isLarge ? "text-sm" : "text-xs"}`}>
            raised
          </p>
        </div>
        <div className="sm:text-right">
          <p
            className={`font-bold text-gray-800 ${isLarge ? "text-3xl" : "text-xl"}`}
          >
            {formatINR(goalValue)}
          </p>
          <p className={`text-gray-500 ${isLarge ? "text-sm" : "text-xs"}`}>
            goal
          </p>
        </div>
      </div>

      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#efc94c] to-[#FF6600] transition-all duration-700"
          style={{ width: `${barWidth}%` }}
        />
      </div>

      <div className="mt-2 text-left">
        <span
          className={`font-semibold text-gray-700 ${isLarge ? "text-base" : "text-sm"}`}
        >
          {percentage}% of goal achieved
        </span>
      </div>
    </div>
  );
}
